import "../styles/bootstrap/bootstrap-grid.scss";
import "../styles/common.scss";
import "../styles/global.scss";
import "../styles/custom/custom.scss";

import "../node_modules/video.js/dist/video-js.min.css";
import "../styles/videojs/markers-plugin.scss";
import "../styles/videojs/player-adaptions.scss";

import 'swiper/swiper.scss';

import "../page-components/player/silvermine-custom.scss";

import React, {useEffect} from "react";
import { AuthProvider } from "../provider/authProvider";
import { DefaultSeo } from 'next-seo';

import posthog from 'posthog-js'

const MyApp = ({ Component, pageProps }) => {

    useEffect(
        () => {
            posthog.init('phc_BSNd8AGKksT3kVQWaTiBF4J126E4kNU7qTRU6ejWSFX', { api_host: 'https://phw2.7hauben.com' })
        },[]
    );

    const noIndex = process.env.NEXT_PUBLIC_NO_INDEX === "true";

    return <>

        <DefaultSeo title={"7hauben | Online-Kochkurse, Rezepte und Videos"}
                    dangerouslySetAllPagesToNoFollow={noIndex}
                    dangerouslySetAllPagesToNoIndex={noIndex}
                    openGraph={
                        {
                            type:'website',
                            title: '7hauben | Online-Kochkurse, Rezepte und Videos',
                            description: 'Hole die Profis zu dir nach Hause und lerne alles übers Kochen und Backen in den praktischen 7hauben-Onlinekochkursen. Jetzt ausprobieren!',
                            images: [
                                { url: 'https://7h-strapi.s3.eu-central-1.amazonaws.com/defaul_seo_image_a0915faca2.jpeg' }
                            ]
                        }
                    } />

        <AuthProvider>
            <Component {...pageProps} />
        </AuthProvider>

    </>;
}

export default MyApp
